import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles
} from '@material-ui/core';
import MUITextField from '@material-ui/core/TextField';
import { AddCircle, Delete } from '@material-ui/icons';
import FormContext from 'components/Form/FormContext';
import ImageWithDropzone from 'components/Image/ImageWithDropzone';
import { getLanguage } from 'features/app/selectors';
import { onChangeMarketSettingsData } from 'features/MarketSettingContainer/actions';
import { LabelImageThumbnail } from 'features/PpsiContainer/constants';
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  tableHeader: {
    background: '#a6c9ec',
    padding: '3px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  inputField: {
    padding: '0px',
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '10px !important',
      borderRadius: '0px'
    }
  },
  addButton: {
    float: 'right'
  }
}));
const dataa = [
  {
    id: 'b6e89f98-5d2d-44db-9dcc-475da207bffd',
    code: 'AT111',
    image_id: 'a80506d7-1f0e-42b1-a736-01dc3e8f4c36',
    name: 'SOUP LADLE 12 cl',
    translated_name: 'SOUP LADLE 12 cl',
    status: 'ACTIVE',
    image: {
      downloadUrl:
        'https://admin.ppsidev.net/uploads/26d19b99-cf84-418b-957e-e28a4284ab9e',
      thumbnailUrl:
        'https://admin.ppsidev.net/uploads/thumbnails-26d19b99-cf84-418b-957e-e28a4284ab9e'
    },

    info: {}
  }
];
const LocalUtensilsTabContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const language = useSelector(getLanguage);
  const { data, setFieldValue } = useContext(FormContext);
  const [utensilsList, setUtensilsList] = useState(data.localPPSIUtensils);

  const addSalesPoint = () => {
    const newUtensils = {
      id: '',
      code: '',
      image_id: '',
      name: '',
      translated_name: '',
      status: 'ACTIVE',
      image: null,
      info: {
        [language]: {
          slug: '',
          name: ''
        }
      }
    };
    setFieldValue('localPPSIUtensils', [...utensilsList, newUtensils]);
    dispatch(
      onChangeMarketSettingsData({
        ...data,
        localPPSIUtensils: [...utensilsList, newUtensils]
      })
    );
    setUtensilsList([...utensilsList, newUtensils]);
  };
  const onDeleteSalesPoint = deletedIndex => {
    const updatedSalesPoints = utensilsList.filter(
      (_, index) => index !== deletedIndex
    );
    setUtensilsList(updatedSalesPoints);
    setFieldValue('localPPSIUtensils', updatedSalesPoints);
    dispatch(
      onChangeMarketSettingsData({
        ...data,
        localPPSIUtensils: updatedSalesPoints
      })
    );
  };

  const onChangeUtensil = (e, index, key) => {
    const updatedValue = e.target.value;
    const updatedList = utensilsList.map((utensil, ind) => {
      if (ind === index) {
        return {
          ...utensil,
          info: {
            ...utensil.info,
            [language]: {
              ...utensil.info[language],
              [key]: updatedValue // Dynamically update slug/name
            }
          }
        };
      }
      return utensil;
    });
    setUtensilsList(updatedList);
    // Sync with form state
    setFieldValue('localPPSIUtensils', updatedList);
    dispatch(
      onChangeMarketSettingsData({ ...data, localPPSIUtensils: updatedList })
    );
  };
  console.log(data, 'data');

  function onChangeMainImage(imgData, i) {
    const updatedList = utensilsList.map((itm, index) => {
      if (index === i) {
        return {
          ...itm,
          image_id: imgData.id,
          downloadUrl: imgData.downloadUrl,
          thumbnailUrl: imgData.thumbnailUrl,
          image: { thumbnailUrl: imgData.thumbnailUrl }
        };
      }
      return itm;
    });
    setUtensilsList(updatedList);
    setFieldValue('localPPSIUtensils', updatedList);
    dispatch(
      onChangeMarketSettingsData({ ...data, localPPSIUtensils: updatedList })
    );
  }

  return (
    <div>
      <Grid
        container
        className={classes.tableHeader}
        spacing={2}
        rowSpacing={1}
      >
        <Grid item sm={4}>
          Name
        </Grid>
        <Grid item sm={5}>
          Translated display text
        </Grid>
        <Grid item sm={2}>
          Related image
        </Grid>
        <Grid item sm={1} />
      </Grid>
      {utensilsList.length > 0 &&
        utensilsList.map((item, index) => {
          return (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item sm={4}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].slug) || ''
                  }
                  onChange={event => onChangeUtensil(event, index, `slug`)}
                />
              </Grid>
              <Grid item sm={5}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].name) || ''
                  }
                  onChange={event => onChangeUtensil(event, index, `name`)}
                />
              </Grid>
              <Grid item sm={2} style={{ textAlign: 'center' }}>
                <div style={{ width: '50px' }}>
                  <ImageWithDropzone
                    image={item.image}
                    thumbnailWidth={LabelImageThumbnail.Width}
                    thumbnailHeight={LabelImageThumbnail.Height}
                    onUploadImage={imgData => onChangeMainImage(imgData, index)}
                    size="xsmall"
                  />
                </div>
              </Grid>
              <Grid item sm={1}>
                {item.id === '' && (
                  <IconButton
                    onClick={() => onDeleteSalesPoint(index)}
                    style={{ color: '#d11a2a' }}
                    size="small"

                    // disabled={isDisable}
                  >
                    <Delete />
                  </IconButton>
                )}
                {index === utensilsList.length - 1 && (
                  <IconButton
                    onClick={addSalesPoint}
                    color="secondary"
                    size="small"
                    // disabled={isDisable}
                    className={classes.addButton}
                  >
                    <AddCircle />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          );
        })}
    </div>
  );
};

export default LocalUtensilsTabContent;
